interface ShortenToggleProps {
  readonly checked: boolean;
  readonly onChange: (checked: boolean) => void;
}

/** Liga/desliga o encurtador (so vale para lojas que permitem; ToS). */
export function ShortenToggle({ checked, onChange }: ShortenToggleProps): JSX.Element {
  return (
    <label className="flex items-center gap-2 text-sm text-foreground">
      <input
        type="checkbox"
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
        className="h-4 w-4 accent-[hsl(var(--primary))]"
      />
      Encurtar quando a loja permitir
    </label>
  );
}
